import { Trans } from "@/shared/scripts/helpers/translation/translation";
import store from "@/shared/store/index";
import thor from "@sl/thor";

export function mapClassifiedTypeToGA4(propertyType: string) {
    const types = {
        "apartment" : "av_2",
        "house" : "av_5",
        "homes_to_build" : "av_5",
        "house_and_apartment" : "av_6",
        "house,apartment" : "av_6",
        "tenement_building" : "av_6",
        "other" : "av_6",
        "office" : "av_7",
        "garage" : "av_8",
        "land" : "av_9",
        "apartment_group" : "av_10",
        "house_group" : "av_10",
        "apartment_group,house_group" : "av_10",
        "new_real_estate_projects" : "av_10",
        "project_construction_houses" : "av_10",
        "industry" : "av_12",
        "commercial" : "av_13",
        "business" : "av_13",
    };

    propertyType = propertyType?.toLowerCase();

    return types?.[propertyType as keyof typeof types] ? types[propertyType as keyof typeof types] : propertyType;
}

export function pushPageViewEvent(screenName : string) :void  {
    thor.pushEvent(
        "page_view",
        {
            "av_user": {
                "uid": store.getters["UserModule/getUser"]?.id,
                "project": store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "WantsToSell" : "WantsToRent",
                "status": store.getters["UserModule/getUser"]?.isAnonymous ? "unlogged" : "logged"
            },
            "av_pagetitle": screenName,
            "av_url_path": window.location.pathname + window.location.hash,
            "av_category": "classified_deposit",
            "av_distribution_type_global": store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "2" : "1",
            "av_estate_type_global": mapClassifiedTypeToGA4(store.getters["FormModule/getValue"]("property.type")),
            "av_estate_subtype": store.getters["FormModule/getValue"]("property.subtype")?.toLowerCase(),
            "av_distribution_subtype": store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE" ? "2" : "1",
            "av_zip_code": store.getters["FormModule/getValue"]("property.location.address.postalCode"),
            "av_environment": process.env.VUE_APP_ENVIRONMENT_NAME !== "prod" ? "preprod" : "prod",
            "av_language": Trans.currentLocale,
            "av_platform" : "web",
            "av_site" : "IWB"
        }
    );
}
